import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    fetchSafetyPlans(farmId) {
        let options = {};
        options = Object.assign({}, options = {
            method: 'get',
            url: `/umbraco/api/SafetyPlans/Get?farmId=${farmId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchSafetyPlan(id) {
        const options = {
            method: 'get',
            url: `/umbraco/api/SafetyPlans/GetById?id=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }
}